import { supabase } from './supabase';
import type { User } from '@supabase/supabase-js';

// De um nome completo ("Maria da Silva") devolve só o primeiro nome, já com a
// inicial maiúscula ("Maria").
export function primeiroNomeDe(nome: string | null | undefined): string {
  const cheio = (nome ?? '').trim();
  if (!cheio) return '';
  const primeiro = cheio.split(/\s+/)[0];
  return primeiro.charAt(0).toUpperCase() + primeiro.slice(1);
}

// Nome para exibir nas telas (saudação do Início, avatar com iniciais).
// Ordem: nome do perfil (vw_meu_perfil → tabela usuarios) → nome do
// user_metadata. Nunca usa o e-mail (nada de "seucheiro").
export async function nomeDeExibicao(userInformado?: User | null): Promise<string> {
  let user = userInformado ?? null;
  if (!user) {
    const { data } = await supabase.auth.getSession();
    user = data.session?.user ?? null;
  }
  if (!user) return '';

  let nome = '';
  try {
    const { data } = await supabase.from('vw_meu_perfil').select('nome').maybeSingle();
    nome = (data as { nome?: string } | null)?.nome ?? '';
  } catch {
    /* segue para o próximo caminho */
  }

  if (!nome) {
    try {
      const { data } = await supabase
        .from('usuarios')
        .select('nome')
        .eq('id', user.id)
        .maybeSingle();
      nome = (data as { nome?: string } | null)?.nome ?? '';
    } catch {
      /* segue para o próximo caminho */
    }
  }

  if (!nome) {
    nome =
      (user.user_metadata?.full_name as string | undefined) ||
      (user.user_metadata?.name as string | undefined) ||
      '';
  }

  return primeiroNomeDe(nome);
}

// Garante que a conta logada tem uma linha na tabela `usuarios`.
// Sem ela, a view vw_inscritos (que faz JOIN em usuarios pelo responsavel_id)
// simplesmente esconderia as inscrições desta pessoa.
export async function garantirUsuario(): Promise<void> {
  // getSession lê o que está guardado (renova se preciso) e NÃO desloga por
  // falha de rede — getUser() de rede podia devolver null e esconder inscrições.
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const user = session?.user ?? null;
  if (!user) return;

  const { data } = await supabase.from('usuarios').select('id').eq('id', user.id).maybeSingle();
  if (data) return;

  const nome =
    (user.user_metadata?.full_name as string | undefined) ||
    (user.user_metadata?.name as string | undefined) ||
    user.email?.split('@')[0] ||
    'Participante';

  await supabase.from('usuarios').insert({
    id: user.id,
    nome,
    email: user.email || '',
    papel: 'usuario',
  });
}